import React from "react";
var __jsx = React.createElement;
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import useIsMobile from "@hooks/useIsMobile";
var FlowBody = function FlowBody(_ref) {
  var _ref$expandable = _ref.expandable,
    expandable = _ref$expandable === void 0 ? false : _ref$expandable,
    isExpanded = _ref.isExpanded,
    children = _ref.children;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: !!isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-flow-body-mobile",
    className: "bg-white rounded-lg"
  }, children)), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-flow-body-desktop",
    className: "max-w-[916px] mx-auto max-h-[685px] min-h-fit bg-white md:mt-[-60px] md:border-2 md:border-solid md:border-gray-echo md:rounded-lg"
  }, children))));
};
export default FlowBody;